// The Marine demo company (for showing prospects VERA Studio): until its fictional records are loaded, the owner sees
// one button that loads them, as one import they can undo in Activity. Every other company never sees this card.

import { useEffect, useState } from "react";
import { crm } from "../lib/crm";
import { useStudio } from "./ui";
import { T } from "../lib/i18n";

export function MarineDemoCard({ onDone }: { onDone: () => void }) {
  const { getToken, toast } = useStudio();
  const [state, setState] = useState<{ present: number; missing: number } | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { crm.marineDemo(getToken).then((r) => setState(r.demo)).catch(() => setState(null)); }, [getToken]);
  if (!state || state.missing === 0) return null;

  async function load() {
    setBusy(true);
    try { const run = await crm.importDemo(getToken); toast(run.summary); setState({ present: state!.present + state!.missing, missing: 0 }); onDone(); }
    catch (e) { toast(e instanceof Error ? e.message : T("That didn't work. Please try again.")); }
    finally { setBusy(false); }
  }

  return (
    <section className="card notice calm row between">
      <span className="mute">{T(state.present ? "The demo company has records you don't have yet." : "This is the demo company. Load its made-up customers, boats, jobs and parts to show VERA Studio.")}</span>
      <button className="btn primary" disabled={busy} onClick={() => void load()}>{busy ? T("Loading…") : T("Load the demo company")}</button>
    </section>
  );
}
